export const CB_NAME = 'AppCookiebotConsentBanner';
export const CD_NAME = 'AppCookiebotCookieDeclaration';
//# sourceMappingURL=constants.js.map